<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3bHqg/tc-custom/9781488017698.jpg?1743832397948" alt="This image is the cover for the book Taking on Twins"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taking on Twins
      </h1>
      <p class="bookDescription body article font2">
        <i><b>Doctor Daddy</b></i><i><b> </b></i><br/><br/>Jake Hadley expects challenges when he returns to his frontier hometown to establish a medical practicebut caring for orphaned toddler twins wasn't part of the equation. The new doctor would be out of his depth without Coralee Evans's help. Once his sweetheart, now his best friend's widow, Coralee has a tender way with the children that makes him long for a second chance. Until Jake is faced with a choice: Coralee or his career <br/><br/>When Jake left Spring Hill for medical school, Coralee believed he'd abandoned her. And though a reunion might be possible, he's working for the man trying to ruin her apothecary business. Could caring for these sweet children bridge the gulf between them and provide a prescription for rekindled love?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mollie Campbell
      </h2>
      
      <p class="authorDescription body article">Mollie Campbell has always had stories in her head but never imagined that writing would turn out to be the perfect fit for her. She loves antiques and watching all the superhero shows and movies she can get her hands on. A life-long Midwestern girl, Mollie lives in central Indiana, where her family has roots back to the 1860s. She is so thankful she gets to spend her days putting together words for people to read and hanging out with her husband, two kids, and a rather enthusiastic beagle.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?306508c2